if (!customElements.get('diva-cherry-card')) {
  customElements.define('diva-cherry-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.select = this.querySelector('select[name="id"]');
      this.button = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('[data-status]');
      this.availability = this.querySelector('[data-availability]');
      if (!this.form || !this.select || !this.button) return;
      this.syncSelection();
      this.select.addEventListener('change', () => { this.status.textContent = ''; this.syncSelection(); });
      this.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        const variant = this.select.selectedOptions[0];
        if (!variant || !variant.value || variant.disabled) return;
        this.pending = true; this.button.disabled = true; this.select.disabled = true;
        this.button.textContent = this.dataset.adding; this.status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(this.querySelector('[data-cart-add-url]').dataset.cartAddUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.value, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
          this.status.textContent = this.dataset.success;
        } catch (error) { this.status.textContent = error.message || this.dataset.error; }
        finally {
          this.pending = false; this.select.disabled = false; this.removeAttribute('aria-busy');
          this.button.textContent = this.dataset.add; this.syncSelection();
        }
      });
    }
    syncSelection() {
      const option = this.select.selectedOptions[0];
      const chosen = Boolean(option && option.value && !option.disabled);
      this.button.disabled = !chosen || this.pending;
      if (chosen) {
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.availability.textContent = this.dataset.available;
      }
    }
  });
}
